module.exports = __webpack_public_path__ + "static/media/car.d4f1d635.svg";